import { useSelector } from 'react-redux';

import {
  selectIsUserProfilePageLookupByUserIdFeatureFlagOn,
  selectIsUuidBasedProject,
  selectUuidProjectType,
  UuidProjectType,
} from 'core/userContext';

import { getAvailableLookupTypes } from '../utils/getAvailableLookupTypes';

export const useAvailableLookupTypes = () => {
  const isLegacyUserIdProject = useSelector(selectIsUserProfilePageLookupByUserIdFeatureFlagOn);
  const isUuidProject = useSelector(selectIsUuidBasedProject);
  const uuidProjectType = useSelector(selectUuidProjectType) || UuidProjectType.EmailUnique;
  return getAvailableLookupTypes(isUuidProject, uuidProjectType, isLegacyUserIdProject);
};
